import { API_ROUTES } from "../../routes/api";
import Attachments from "../../components/attachments";

export default function AddEditPOE({ type, obj, route }) {
    return <Attachments type={type} route={route} id={obj.id} indicator={obj.indicator} />;
}
